import { AuthGate } from '@/components/auth/auth-gate';
import { ThemeProvider } from '@/components/theme/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, HeadContent, Outlet } from '@tanstack/react-router';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

const RootLayout = () => (
    <>
        <QueryClientProvider client={queryClient}>
            <HeadContent />
            <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
                <AuthGate>
                    <Outlet />
                </AuthGate>
                <Toaster />
            </ThemeProvider>
            {import.meta.env.DEV && (
                <>
                    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                    {/* <TanStackRouterDevtools /> */}
                </>
            )}
        </QueryClientProvider>
    </>
);

export const Route = createRootRoute({ component: RootLayout });
